import React from "react";
import Button from "../../Button";

import CgmChargingImage from "src/assets/images/cgm/connection-journey/cgm-charging.png";
import CgmChargingLightsImage from "src/assets/images/cgm/connection-journey/cgm-charging-lights.png";

type DeviceReadyStepProps = {
  onContinue: () => void;
};

const DeviceReadyStep: React.FC<DeviceReadyStepProps> = ({ onContinue }) => {
  return (
    <div className="relative min-h-max flex flex-col items-center justify-center">
      <h1 className="pt-4 pb-3 text-2xl font-bold text-[var(--text-primary)]">
        Before Y﻿ou Start
      </h1>
      <p className="text-sm text-[var(--text-secondary)] opacity-80 mb-6 text-center px-4">
        Make sure your transmitter is fully charged. Put it in the charging pod
        until the blinking white light turns{" "}
        <span className="font-semibold text-gray-700">blue</span>. This takes
        about 15 minutes
      </p>
      <div className="relative mt-10 space-y-10">
        <img
          src={CgmChargingImage}
          alt="CGM Charging"
          className="w-full h-auto"
        />
        <img
          src={CgmChargingLightsImage}
          alt="CGM Charging Lights"
          className="absolute top-0 left-0 w-full h-auto"
        />
      </div>
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100">
        <Button
          onClick={onContinue}
          variant="contained"
          rounded="full"
          fullWidth
        >
          Start Connection Journey
        </Button>
      </div>
    </div>
  );
};

export default DeviceReadyStep;
